"use strict";

var _ = require('lodash');
module.exports = {
    /**
     * Takes API data and turns it into a DTO that describes that data.
     * @param location element from getLocations service resp
     * @param formatted location data object
     */
    fromLocationToDTO: function fromLocationToDTO(el) {
        var date = new Date();
        var day = date.getDay();

        var hours = null;
        var getAmPm = function getAmPm(timeArray) {

            var hours24 = Number(timeArray[0]);
            var minutes = Number(timeArray[1]);

            var time = "" + ((hours24 + 11) % 12 + 1); // get hours
            time += minutes < 10 ? ":0" + minutes : ":" + minutes; // get minutes
            time += hours24 > 11 ? " pm" : " am"; // get AM/PM

            return time;
        };

        var open = el.daysOfWeek && el.daysOfWeek[day].openTime && el.daysOfWeek[day].openTime.trim() != '' ? el.daysOfWeek[day].openTime.split(":") : null;
        var close = el.daysOfWeek && el.daysOfWeek[day].closeTime && el.daysOfWeek[day].closeTime.trim() != '' ? el.daysOfWeek[day].closeTime.split(":") : null;

        if (open && close && (open[0].trim().length !== 0 || close[0].trim().length !== 0)) {
            open = getAmPm(open);
            close = getAmPm(close);
            hours = open + ' - ' + close;
        } else {
            hours = false;
        }

        var formattedPhone = el.phone && _.isString(el.phone) ? '(' + el.phone.substring(0, 3) + ') ' + el.phone.substring(3, 6) + '-' + el.phone.substring(6, 10) : el.phone;

        return {
            title: el.name,
            address1: el.address1,
            address2: el.address2,
            phone: el.phone,
            formattedPhone: formattedPhone,
            hours: hours,
            isFavorite: false,
            services: [],
            distance: el.distance,
            hasMobileOrder: el.hasMobileOrder,
            hasBreakfast: el.hasBreakfast,
            hasCSO: el.hasCSO,
            hasCokeFreestyle: el.hasCokeFreestyle,
            hasDigitalCoupon: el.hasDigitalCoupon,
            hasHola: el.hasHola,
            hasLoyalty: el.hasLoyalty,
            hasMCX: el.hasMCX,
            hasMobilePay: el.hasMobilePay,
            hasWifi: el.hasWifi,
            isOpenLate: el.isOpenLate,
            isOpen24Hours: el.isOpen24Hours,
            location: {
                lat: el.lat,
                lon: el.lng
            },
            id: el.id
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/mappers/location.js
// module id = 845
// module chunks = 0